export default __webpack_public_path__ + "static/media/404.3f0d1056.svg";